import WebApp from '@twa-dev/sdk';

import { isObjectEmpty } from '../is-object-empty';

type OpeningMethod =
  | 'sender'
  | 'private'
  | 'group'
  | 'supergroup'
  | 'channel'
  | 'profile_button_or_inline_button_or_chat_menu_button'
  | 'unknown'
  | 'keyboard_button_or_inline_mode';

export const getOpeningMethod = (): OpeningMethod => {
  let openingMethod: OpeningMethod = 'unknown';

  // InitData is empty if the Mini App was launched from a keyboard button or from inline mode.
  // https://core.telegram.org/bots/webapps#webappinitdata
  if (isObjectEmpty(WebApp?.initDataUnsafe) || !WebApp?.initDataUnsafe?.chat_type)
    openingMethod = 'keyboard_button_or_inline_mode';

  //

  // Optional. Type of the chat from which the Mini App was opened. Can be either “sender” for a private chat with the user opening the link, “private”, “group”, “supergroup”, or “channel”.
  // Returned only for Mini Apps launched from direct links
  // https://core.telegram.org/bots/webapps#webappinitdata
  if (WebApp?.initDataUnsafe?.chat_type === 'sender') {
    openingMethod = 'profile_button_or_inline_button_or_chat_menu_button';
  } else {
    openingMethod = WebApp?.initDataUnsafe?.chat_type as OpeningMethod;
  }

  return openingMethod;
};
